// @ts-nocheck
import create from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { axios } from './axios';

const baseUrl = `${process.env.API_URL}/api/v1`;

const useUserProfileStore = create(immer((set) => ({
  userProfiles: [],
  profileFields: [],

  getUserProfilesByOrganization: async (orgRef) => {
    if (!orgRef) return;
    try {
      const { data } = await axios.get(
        `${baseUrl}/userProfiles?organization=${encodeURIComponent(orgRef)}`,
      );
      set((state) => {
        state.userProfiles = data?.result?.profiles || [];
        state.profileFields = data?.result?.profileFields || [];
      });
    } catch (error) {
      console.error('Error in getUserProfilesByOrganization:', error);
    }
  },
})));

export default useUserProfileStore;
